<style scoped lang="scss">
    .chat {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: #000000;
    }

    .playbox {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0px;
    }

    .toolbar {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 60px;
        background-color: #2d3947;

        li {
        }

        img {
            height: 30px;
        }


        .subs {
            width: 15px;
            background-repeat: no-repeat;
            background-position: center center;

            &:hover {
                background-color: #333333;
            }
        }
    }

    .playbox {
        li {
            border: 1px solid #FFFFFF;
        }
    }

    video {
        width: 256px;
        height: 192px;
    }
</style>
<template>
    <div class="chat">
        <div class="playbox">
            <ul class="flex jcc">
                <li>
                    <video ref="local" id="local" autoplay muted :style="localStyle"></video>
                </li>
                <li v-for="(player,index) in players" :key="index" v-show="!player.self">
                    <video :id="'video'+player.id" autoplay v-if="!player.self"></video>
                    <audio :id="'audio'+player.id" autoplay v-if="!player.self"></audio>
                </li>
            </ul>
            <div class="big">
            </div>
        </div>
    </div>
</template>

<script>
  import {
    openCameraAndPubVideo,
    openMicrophone,
    tee3CallDevice,
    tee3checkDevice,
    tee3getAccessToken,
    tee3getPlayers,
    tee3init,
    tee3join,
    tee3OpenScreenAndPub,
    tee3StartLive,
    tee3StopLive
  } from "../../../lib/video/tee3";

  const btns = [];
  export default {
    name: "chat",
    data() {
      return {
        query: {},
        btns,
        players: []
      }
    },
    computed: {
      toolbar() {
        return this.btns;
      },
      localStyle() {
        return {}
      }
    },
    created() {
      this.query = this.$route.query;
      bus.$on('onUserJoinNotify', () => {
        this.players = tee3getPlayers();
      });
      bus.$on('onSubscribleCameraResult', (stream, userId) => {
        this.setVideoAndAudio('video', stream, userId);
      });
    },
    async mounted() {
      const res = await tee3checkDevice();
      if (!res.audio) {
        //音频不存在
      } else if (!res.video) {
        //视频不可用
      } else {
        try {
          let token = await tee3getAccessToken();
          await tee3init(token);
          await tee3join(this.query.room, hex_md5(Math.random() + ''), hex_md5(Math.random() + ''));
          openCameraAndPubVideo(this.$refs.local);
          openMicrophone();
          this.players = tee3getPlayers();
        } catch (e) {
          throw e;
        }
      }
    },
    methods: {
      setVideoAndAudio(type, stream, userId, times = 1) {
        let dom = document.getElementById(type + userId);
        if (dom) {
          console.dir(dom);
          dom.srcObject = stream;
        } else if (times === 150) {
          Log('dom ' + type + userId + ' 不存在');
        } else {
          setTimeout(() => {
            times++;
            this.setVideoAndAudio(type, stream, userId, times);
          }, 200);
        }
      },
      handler(bar) {
        const map = new Map([
          ['加入设备', async () => {
            tee3CallDevice('15015015000', 'demo', 'sip:1006@47.96.119.149:6060')
          }],
          ['ppt分享', async () => {
            tee3OpenScreenAndPub();
          }],
          ['开始直播', async () => {
            tee3StartLive('15015015000', 'lmw', 'rtmp://vstream.diandianys.com/20190627/20190627?auth_key=1563428763-0-0-59fc832dbb23cb031a70037130197a91');
          }],
          ['停止离开', async () => {
            tee3StopLive('15015015000', 'lmw');
          }]
        ]);
        let fun = null;
        for (let [key, func] of map) {
          if (key === bar.name) fun = func;
        }
        fun.apply(this);
      }
    },
  }
</script>
